import SendIcon from 'assets/icons/send.svg';
import { ChatInputProps } from 'interfaces/components/chatbot/ChatInput';

const ChatInput = ({
  inputValue,
  onInputChange,
  onSendMessage,
  onKeyPress,
  onKeyDown,
  isLoading,
  showSuggestions,
  focusedIndex,
  onSuggestionClick,
  autocompletions 
}: ChatInputProps) => {


  const filteredSuggestions = autocompletions?.suggestions || [];


  return (
    <div className='relative'>
      <div className='relative'>
        <input
          type='text'
          value={inputValue}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          placeholder='Ask anything'
          disabled={isLoading}
          className='w-full pl-4 px-9 py-3 leading-[18px] border border-gray-400 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed'
        />
        <button
          id='send-message-button'
          onClick={onSendMessage}
          disabled={isLoading || !inputValue.trim()}
          className='absolute right-2 top-1/2 transform -translate-y-1/2 disabled:opacity-50 disabled:cursor-not-allowed'
        >
          <img src={SendIcon} alt='Send' className='w-6 h-6' />
        </button>
      </div>

      {showSuggestions && filteredSuggestions.length > 0 && (
        <div
          data-autocomplete-dropdown
          className='absolute top-full left-0 right-0 mt-1 max-h-[110px] overflow-y-auto bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg shadow-lg z-[9999]'
          onKeyDown={onKeyDown}
          tabIndex={-1}
        >
          {filteredSuggestions.map((suggestion: { QUESTIONS: string }, index: number) => (
            <button
              key={index}
              onClick={() => onSuggestionClick(suggestion.QUESTIONS)}
              className={`w-full text-left px-3 py-2 text-base transition-colors duration-150 first:rounded-t-lg last:rounded-b-lg ${
                index === focusedIndex
                  ? 'bg-green-100 dark:bg-green-800 text-green-800 dark:text-green-200 border-l-4 border-green-500'
                  : 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200'
              }`}
              data-suggestion-index={index}
            >
              {suggestion.QUESTIONS}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChatInput;
